import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';

import './media-contacts-card.scss';

export function MediaContactsCard({ entry, fill = true }) {
  const {
    title,
    description,
    'item-image': itemImage,
    'link-text': linkText,
    'link-url': linkUrl,
    phone,
  } = entry.getAllMetadata();
  const titleText = typeof title === 'string' ? title : '';
  const descriptionText = typeof description === 'string' ? description : '';

  return (
    <div className={classNames('media-contacts-card d-flex flex-column', { 'h-100': fill })}>
      {!!itemImage && <Image imageId={itemImage} source="" alt="" className="media-contacts-card__photo mb-1" lazy />}
      <h3 className="size-16 fw-bold mb-0 text-gray-darker">{titleText}</h3>
      <hr className="mt-0_25 mb-0_25" />
      {!!descriptionText && <p className="size-14 text-gray-dark mb-0_25">{descriptionText}</p>}
      {!!linkUrl && (
        <Link to={linkUrl} className="size-14 mb-0_25">
          {linkText}
        </Link>
      )}
      {!!phone && <span className="size-14 text-gray-dark">{phone}</span>}
    </div>
  );
}

MediaContactsCard.propTypes = {
  entry: CmsEntities.Content.isRequired,
  fill: PropTypes.bool,
};
